import { Navigate, createBrowserRouter, useLocation } from "react-router-dom"
import { useAppSelector } from "../store/store"
import React from "react"

import Template from "../pages/Template"

import HomePage from "../pages/Home"

import PlayerPage from "../pages/Player"

import LoginPage from "../pages/Login"


import AwardsTemplate from "../pages/Awards"
import AwardsMainPage from "../pages/Awards/Main"
import AwardCreatePage from "../pages/Awards/Create"
import AwardOverviewPage from "../pages/Awards/Overview"
import PlayerOverviewPage from "../pages/Player/Overview"
import PlayerAwardsPage from "../pages/Player/Awards"
import PlayerEditPage from "../pages/Player/Edit"
import PlayerTeamsPage from "../pages/Player/Teams"
import RankingPage from "../pages/Ranking"
import HistoricalPage from "../pages/Ranking/Historical"
import SeasonPage from "../pages/Ranking/Season"
import LeaguePage from "../pages/League"
import FirstDivisionPage from "../pages/League/FirstDivision"
import SecondDivisionPage from "../pages/League/SecondDivision"
import ThirdDivisionPage from "../pages/League/ThirdDivision"
import HomeLeaguePage from "../pages/League/Home"
import CreateTeamPage from "../pages/Teams/Create"
import TeamsTemplate from "../pages/Teams"
import TeamOverview from "../pages/Teams/Overview"
import TeamMembersPage from "../pages/Teams/Members"
import TimelinePage from "../pages/Teams/Timeline"
import WalletPage from "../pages/Teams/Wallet"
import ContractsPage from "../pages/Teams/Contracts"
import PlayerContractsPage from "../pages/Player/Contracts"
import PlayerWalletPage from "../pages/Player/Wallet"
import AdminsPage from "../pages/Admins"
import RecordsPage from "../pages/Records"
import PlayersPage from "../pages/Home/Players"
import TeamsPage from "../pages/Home/Teams"

interface ComponentWithChildren {
    children: JSX.Element
}

export const AuthRequired: React.FC<ComponentWithChildren> = ({ children }) => {
    const token = useAppSelector(state => state.token)
    const location = useLocation()

    if (!token) {
        return <Navigate to="/" state={{ from: location }} replace />
    }
    return children
}

export const AuthNoRequired: React.FC<ComponentWithChildren> = ({ children }) => {
    const token = useAppSelector(state => state.token)
    const location = useLocation()

    if (token) {
        return <Navigate to="/" state={{ from: location }} replace />
    }
    return children
}

const router = createBrowserRouter([
    {
        path: "/",
        element: <Template />,
        children: [
            {
                path: "/",
                element: <HomePage />,
                children: [
                    {
                        path: "",
                        element: <PlayersPage />
                    },
                    {
                        path: "teams",
                        element: <TeamsPage />
                    }
                ]
            },

            {
                path: "/admins/",
                element: <AdminsPage />
            },
            {
                path: "/records",
                element: <RecordsPage />
            },
            {
                path: "/ranking",
                element: <RankingPage />,
                children: [
                    {
                        path: "historical",
                        element: <HistoricalPage />
                    },
                    {
                        path: "season",
                        element: <SeasonPage />
                    },
                ]
            },

            {
                path: "/league",
                element: <LeaguePage />,
                children: [
                    {
                        path: "",
                        element: <HomeLeaguePage />
                    },
                    {
                        path: "first-division",
                        element: <FirstDivisionPage />
                    },
                    {
                        path: "second-division",
                        element: <SecondDivisionPage />
                    },
                    {
                        path: "third-division",
                        element: <ThirdDivisionPage />
                    },
                ]
            },

            {
                path: "/p/:playerName",
                element: <PlayerPage />,
                children: [
                    {
                        path: "",
                        element: <PlayerOverviewPage />,
                    },
                    {
                        path: "awards",
                        element: <PlayerAwardsPage />
                    },
                    {
                        path: "edit",
                        element: <AuthRequired><PlayerEditPage /></AuthRequired>
                    },
                    {
                        path: "teams",
                        element: <PlayerTeamsPage />
                    },
                    {
                        path: "wallet",
                        element: <AuthRequired><PlayerWalletPage /></AuthRequired>
                    }
                ]
            },


            {
                path: "/create-team",
                element: <CreateTeamPage />
            },

            {
                path: "/teams/:teamSlug",
                element: <TeamsTemplate />,
                children: [
                    {
                        path: "",
                        element: <TeamOverview />
                    },
                    {
                        path: "members",
                        element: <TeamMembersPage />
                    },
                    {
                        path: "timeline",
                        element: <TimelinePage />
                    },
                    {
                        path: "wallet",
                        element: <WalletPage />
                    },
                    {
                        path: "contracts",
                        element: <ContractsPage />
                    },
                ]
            },

            {
                path: "/awards",
                element: <AwardsTemplate />,
                children: [
                    {
                        path: "",
                        element: <AwardsMainPage />
                    },
                    {
                        path: "create",
                        element: <AuthRequired><AwardCreatePage /></AuthRequired>
                    },
                    {
                        path: ":awardId/edit",
                        element: <AuthRequired><AwardCreatePage /></AuthRequired>
                    },
                    {
                        path: ":awardId/overview",
                        element: <AwardOverviewPage />
                    },

                ]
            },
            {
                path: "/login",
                element: <AuthNoRequired><LoginPage /></AuthNoRequired>
            },
        ]
    },
])

export default router